import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { JobMonitoringService } from './job-monitoring.service';
import { MonitoredJob } from './monitored-job';

export const monitoredJobsResolver: ResolveFn<Array<MonitoredJob>> = (): Observable<Array<MonitoredJob>> => {
	return inject(JobMonitoringService)
		.getJobs();
}